import { codeLangConfig3, CODE_LANG_KEY } from '../lang'

function generateCodeJson(api, codeLang, host, defaultCode) {

  const code = codeLangConfig3.find(item => item.value === codeLang)

  if (!code) {
    return defaultCode || 'No Code'
  }
  const api2 = {}
  let codeStr = require("@/utils/codeJson/" + codeLang + '.js').default

  if (code.value === CODE_LANG_KEY.js) {
    api2.uri = api.uri
    api2.method = api.method
    api2.payload = api.payload
    api2.protocol = api.protocol
    codeStr = codeStr.replace(/AAPPII/g, JSON.stringify(api2, null, 4))
    codeStr = codeStr.replace(/HHOOSSTT/g, host)
    return codeStr
  } else if (codeLang == CODE_LANG_KEY.shell) {
    let parameters = ""
    for (const key in api.payload) {
      parameters += key + "=" + api.payload[key] + "&"
    }
    if (parameters) {
      parameters = parameters.substring(0, parameters.length - 1)
    }
    codeStr = codeStr.replace(/AAPPII/g, api.uri)
    codeStr = codeStr.replace(/HHOOSSTT/g, host)
    codeStr = codeStr.replace(/PPRROOTTOOCCOOLL/g, api.protocol)
    codeStr = codeStr.replace(/MMEETTHHOODD/g, api.method)
    codeStr = codeStr.replace(/PPAARRAAMMEETTEERRSS/g, parameters)
    codeStr = codeStr.replace(/\^/g, '`')
    return codeStr
  } else if (codeLang === CODE_LANG_KEY.go) {
    api2.uri = api.uri
    api2.method = api.method
    // api2.payload = api.payload
    api2.protocol = api.protocol
    codeStr = codeStr.replace(/\^/g, '`')
    codeStr = codeStr.replace(/AAPPII/g, JSON.stringify(api2, null, 4))
    codeStr = codeStr.replace(/PPAAYYLLOOAADD/g, JSON.stringify(api.payload, null, 4))
    codeStr = codeStr.replace(/HHOOSSTT/g, host)
    return codeStr
  } else if (codeLang === CODE_LANG_KEY.java) {
    // codeStr = require("@/utils/code/" + codeLang + '.js').default
    api2.uri = api.uri
    api2.method = api.method
    api2.protocol = api.protocol
    codeStr = codeStr.replace(/\^/g, '`')
    codeStr = codeStr.replace(/AAPPII/g, api2.uri)
    let str = ``
    for (const prop in api.payload) {
      str += `
        parameters.put("${prop}", "");`
    }
    codeStr = codeStr.replace(/PPAAYYLLOOAADD/g, str)
    codeStr = codeStr.replace(/HHOOSSTT/g, host)
    codeStr = codeStr.replace(/MMEETTHHOODD/g, api2.method)
    codeStr = codeStr.replace(/PPRROOTTOOCCOOLL/g, api2.protocol)

    return codeStr
  } else if (codeLang === CODE_LANG_KEY.python) {
    api2.uri = api.uri
    api2.method = api.method
    // api2.payload = api.payload
    api2.protocol = api.protocol
    codeStr = codeStr.replace(/\^/g, '`')
    codeStr = codeStr.replace(/AAPPII/g, api2.uri)
    codeStr = codeStr.replace(/PPAAYYLLOOAADD/g, JSON.stringify(api.payload, null, 4))
    codeStr = codeStr.replace(/HHOOSSTT/g, host)
    codeStr = codeStr.replace(/PPRROOTTOOCCOOLL/g, api2.protocol)
    codeStr = codeStr.replace(/MMEETTHHOODD/g, api2.method)

    return codeStr
  }  else if (codeLang === CODE_LANG_KEY.csharp) {
    api2.uri = api.uri
    api2.method = api.method
    // api2.payload = api.payload
    api2.protocol = api.protocol
    let payloadStr = JSON.stringify(api.payload, null, 4)
    payloadStr = payloadStr.replace(/:/g, "=")
    payloadStr = payloadStr.replace(/\"/g, "")

    codeStr = codeStr.replace(/\^/g, '`')
    codeStr = codeStr.replace(/AAPPII/g, api2.uri)
    codeStr = codeStr.replace(/PPAAYYLLOOAADD/g, payloadStr)
    codeStr = codeStr.replace(/HHOOSSTT/g, host)
    codeStr = codeStr.replace(/PPRROOTTOOCCOOLL/g, api2.protocol)
    codeStr = codeStr.replace(/MMEETTHHOODD/g, api2.method)

    return codeStr
  }  else if (codeLang === CODE_LANG_KEY.php) {
    api2.uri = api.uri
    api2.method = api.method
    // api2.payload = api.payload
    api2.protocol = api.protocol
    let payloadStr = JSON.stringify(api.payload, null, 4)
    payloadStr = payloadStr.replace(/:/g, "=")
    payloadStr = payloadStr.replace(/\"/g, "")

    codeStr = codeStr.replace(/\^/g, '`')
    codeStr = codeStr.replace(/AAPPII/g, api2.uri)
    codeStr = codeStr.replace(/PPAAYYLLOOAADD/g, payloadStr)
    codeStr = codeStr.replace(/HHOOSSTT/g, host)
    codeStr = codeStr.replace(/PPRROOTTOOCCOOLL/g, api2.protocol)
    codeStr = codeStr.replace(/MMEETTHHOODD/g, api2.method)

    return codeStr
  }  else {
    return defaultCode || 'No Code'
  }
}

export default generateCodeJson



// WEBPACK FOOTER //
// ./src/utils/codeJson/generate.js